import React from 'react'
import { Heading } from '@chakra-ui/react'
import { httpToHttps } from '../../utils/helper-functions'

export const BackgroundBanner = ( props ) => {
  const { artist, hotSongs, album } = props
  // Incase of unavailable artist image (Needs a proper workaround )
  let coverImg = artist?.picId !== 0 || artist?.img1v1Id !== 18686200114669622 ? artist?.picUrl : hotSongs[0]?.blurPicUrl
  let backgroundImg = artist !== undefined ? httpToHttps( artist?.picId !== 0 ? artist?.picUrl + "?param=900y600" : coverImg ) : httpToHttps( album?.blurPicUrl + "?param=900y600" || album?.artist?.picUrl + "?param=900y600" )
  return (
    <div
      className="artist__background"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 30%',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        maxHeight: '300px',
        height: '30vh',
        filter: 'contrast(120%)',
        backgroundColor: 'black',
        position: "relative"
      }}>
      <div className="banner__img"
        style={{
          background: 'linear-gradient(#ffff 0%, #000000b3 100%), url(`${httpToHttps(hotSongs[0]?.blurPicUrl?param=900y600 )}`)'
        }}
      />
      <Heading
        as="h1"
        fontSize={{ base: '2em', md: '3em', lg: '5em', xl: '7em' }}
        color="brand.mainYellow"
        textTransform="uppercase"
        fontFamily="Poppins"
        fontWeight="black"
        w="100%"
        textAlign="left"
        filter='brightness(180%)'
        position="absolute"
        bottom="0"
        verticalAlign="middle"
      // marginBottom={{ base: 0, md: 0, lg: 4, xl: 6 }}
      >
        {artist?.name}
      </Heading>
    </div >
  )
}
